import Immutable from 'immutable';

import Countries from '../constants/Countries';

const Country = new Immutable.Record({ name: null, iso2: null });

const countries = Immutable.fromJS(Countries.map(([ name, iso2 ]) => new Country({ name, iso2 })));

class CountryStore {
    getCountries () {
        return countries;
    }

    getCountry (iso2) {
        return countries.find((country) => country.iso2 === iso2);
    }
}

const storeInstance = new CountryStore();

export default storeInstance;
